export const getConditionsModelString = (model, operator, startCount = 0) => {
  const baseValue = model
    .map((_, i, arr) => {
      if (i === 0 && arr.length === 1) {
        return `${startCount + i + 1}`
      }
      return i + 1 < arr.length
        ? `${startCount + i + 1} ${operator.toUpperCase()}`
        : `${startCount + i + 1}`
    })

  return baseValue
    .join(" ")
    .trim();
};
